export default {
  userInfo: state => state.userInfo
}